module.exports = "<div class=\"hpanel employee-card-list\" ng-repeat=\"employee in $ctrl.employees\">\n  <employee-card\n    employee-id=\"employee.id\"\n    first-name=\"employee.firstName\"\n    last-name=\"employee.lastName\"\n    profile-pic=\"employee.profilePic\">\n  </employee-card>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./client/pages/admin/project-details/components/employee-card-list/employee-card-list.html
// module id = 987
// module chunks = 0